"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ng1UpgradedAngularJsWrapper = void 0;
const core_1 = require("@angular/core");
const static_1 = require("@angular/upgrade/static");
const i0 = __importStar(require("@angular/core"));
class Ng1UpgradedAngularJsWrapper extends static_1.UpgradeComponent {
    constructor(elementRef, injector) {
        // We must pass the name of the directive as used by AngularJS to the super
        super('upgradedAngularJsCtrl', elementRef, injector);
    }
}
exports.Ng1UpgradedAngularJsWrapper = Ng1UpgradedAngularJsWrapper;
Ng1UpgradedAngularJsWrapper.ɵfac = function Ng1UpgradedAngularJsWrapper_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || Ng1UpgradedAngularJsWrapper)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector)); };
Ng1UpgradedAngularJsWrapper.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: Ng1UpgradedAngularJsWrapper, selectors: [["ng1-upgraded-angular-js"]], inputs: { inputParam: "inputParam" }, outputs: { outputParam: "outputParam" }, features: [i0.ɵɵInheritDefinitionFeature] });
